import * as React from "react";
import { CovidCaseByCountry_covidCaseOwidByCountry_latest } from "../../../../../apollo-types/CovidCaseByCountry";
import { Colors } from "../../../../design-tokens/colors";
import styles from "./country-progress-bar.styles";

const getPercentageValue = (value: number) => {
  if (value < 0 || value > 1) {
    return null;
  }
  return `${Math.round(value * 1000) / 10}%`;
};

const CountryProgressBar: React.FC<CovidCaseByCountry_covidCaseOwidByCountry_latest> = ({
  totalCases,
  totalActive,
  totalDeaths,
  totalRecovered,
}) => {
  if (!totalCases || !totalDeaths) {
    return null;
  }

  const activePercent = (totalActive && totalActive / totalCases) || 0;
  const deathPercent = totalDeaths / totalCases || 0;
  const recoveredPercent = (totalRecovered && totalRecovered / totalCases) || 0;

  return (
    <div css={styles.root}>
      <div css={styles.progressBar}>
        <div
          css={{
            height: "100%",
            width: getPercentageValue(activePercent) || 0,
            backgroundColor: Colors.Orange,
          }}
        />
        <div
          css={{
            height: "100%",
            width: getPercentageValue(recoveredPercent) || 0,
            backgroundColor: Colors.Green,
          }}
        />
        <div
          css={{
            height: "100%",
            width: getPercentageValue(deathPercent) || 0,
            backgroundColor: Colors.Red,
          }}
        />
      </div>

      <div css={styles.progressLabel}>
        <div css={styles.legend}>
          {getPercentageValue(activePercent) && (
            <>
              <div
                css={[styles.indicator, { backgroundColor: Colors.Orange }]}
              />
              Active {getPercentageValue(activePercent)}
            </>
          )}
        </div>
        <div css={styles.legend}>
          {getPercentageValue(recoveredPercent) && (
            <>
              <div
                css={[styles.indicator, { backgroundColor: Colors.Green }]}
              />
              Recoveries {getPercentageValue(recoveredPercent)}
            </>
          )}
        </div>
        <div css={styles.legend}>
          <div css={[styles.indicator, { backgroundColor: Colors.Red }]} />
          Death {getPercentageValue(deathPercent)}
        </div>
      </div>
    </div>
  );
};

export default CountryProgressBar;
